// extracted by mini-css-extract-plugin
export var active = "PricingSection-module--active--c815b";
export var activeButton = "PricingSection-module--activeButton--0bab2";
export var aiHighlight = "PricingSection-module--aiHighlight--2f858";
export var aiHighlightHeading = "PricingSection-module--aiHighlightHeading--5d6b2";
export var aiHighlightIcon = "PricingSection-module--aiHighlightIcon--91188";
export var aiHighlightItem = "PricingSection-module--aiHighlightItem--09cc0";
export var aiHighlightSparkle = "PricingSection-module--aiHighlightSparkle--b368c";
export var badge = "PricingSection-module--badge--ece22";
export var bold = "PricingSection-module--bold--0bd7a";
export var button = "PricingSection-module--button--6842a";
export var description = "PricingSection-module--description--6359b";
export var header = "PricingSection-module--header--8c81c";
export var iconWrap = "PricingSection-module--iconWrap--d0b87";
export var price = "PricingSection-module--price--13766";
export var priceLine = "PricingSection-module--priceLine--1fc02";
export var priceUnit = "PricingSection-module--priceUnit--bb7dc";
export var pricingContainer = "PricingSection-module--pricingContainer--8ffc3";
export var pricingWrapper = "PricingSection-module--pricingWrapper--1ac3b";
export var root = "PricingSection-module--root--dac04";
export var tag = "PricingSection-module--tag--2b8a6";
export var tick = "PricingSection-module--tick--07f6e";
export var tierIcon = "PricingSection-module--tierIcon--0d461";
export var title = "PricingSection-module--title--b6601";
export var titleContainer = "PricingSection-module--titleContainer--4e191";